import styled from "styled-components";
import { grayColor } from "~/components/layout/Variables";

export const ContainerType = styled.div`
  margin: 2rem 0;

  @media(min-width: 770px) {
    margin: 1rem 0;
  }
`;

export const ItemCard = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  img {
    margin: 0.5rem 0 0.5rem 1rem;
  }

  &:not(:first-child) {
    border-top: 0.6px solid rgba(150, 150, 150, 0.5);
  }
`;

export const ItemDropDown = styled.div`
  display: flex;
  flex-direction: column;

  &:not(:first-child) {
    border-top: 0.6px solid rgba(150, 150, 150, 0.5);
  }
`;

export const TextCard = styled.p`
  margin: 0;
  color: ${() => grayColor};
  padding: ${(props) => props.padding};
`;

export const SelectBranches = styled.select`
  width: 92%;
  font-size: 1.2rem;
  color: #949494;
  border: 0.6px solid rgba(80,80,80,0.3);
  background-color: #fff;
  box-shadow: 0px 2px 2px #00000029;
  border-radius: 0.4rem;
  padding: 0.3rem 1rem;
  margin: ${props => props.margin ? props.margin : '0 .75rem 1rem'};
  -webkit-appearance: none;
  -moz-appearance: none;
  text-indent: 1px;
  text-overflow: '';
  background: url(http://cdn1.iconfinder.com/data/icons/cc_mono_icon_set/blacks/16x16/br_down.png) no-repeat right;
  background-position: 95% .7rem;
  opacity: .7;
`